import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Province from '../../models/Province'

export interface ProvinceListState extends PaginatedApiState {
  provinces?: Province[]
}

const ProvinceList = (state: ProvinceListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ProvinceListState>('PROVINCE_LIST')(state, action)
  }
}

export default ProvinceList
